<template>
  <v-dialog
    v-model="valid"
    persistent
    max-width="900px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">SMS Mesaj İçeriği Oluşturma</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="prepare"
            lazy-validation
          >
            <v-row>
              <!-- SOL -->
              <v-flex
                xs12
                md4
              >
                <v-flex
                  xs12
                  class="pb-0"
                >
                  <!-- GÖNDERİCİ ADI -->
                  <senders-or-message-types
                    label="Gönderici Adları"
                    required
                    :default="data.senders[0]"
                    :rules="[
                      $rules.required({
                        falseValues: [undefined, null],
                        message: 'Gönderici adı seçimi yapmalısınız',
                      }),
                    ]"
                    :items="data.senders"
                    @on:model-update="
                      (val) => {
                        prepareSms.sender = val;
                      }
                    "
                  >
                  </senders-or-message-types>
                </v-flex>
                <v-flex
                  xs12
                  class="pt-0 pb-0"
                >
                  <!-- TÜR -->
                  <senders-or-message-types
                    label="Tür"
                    required
                    :rules="[
                      $rules.required({
                        falseValues: [undefined, null],
                        message: 'Mesaj türü seçimi yapmalısınız',
                      }),
                    ]"
                    :items="types"
                    :default="data.default_message_type"
                    item-text="text"
                    item-value="value"
                    @on:model-update="
                      (val) => {
                        prepareSms.message_type = val;
                      }
                    "
                  >
                  </senders-or-message-types>
                </v-flex>
                <v-flex
                  xs12
                  class="pt-0 pb-0"
                >
                  <!-- ŞABLON -->
                  <template-selector
                    label="Şablon Seçinizi"
                    :items="data.templates"
                    @on:template-selected="
                      (val) => {
                        msgBox = val.content;
                      }
                    "
                  >
                  </template-selector>
                </v-flex>
                <v-flex xs12>
                  <!-- GÖNDERİM ZAMANI -->
                  <time-type
                    :rules="[
                      $rules.required({
                        falseValues: [undefined, null],
                        message: 'Gönderim zamanı seçimi yapmalısınız',
                      }),
                    ]"
                    @type:update="(val) => (wTimeStat = val)"
                  >
                  </time-type>
                </v-flex>
                <v-flex
                  xs12
                  class="pt-0 pb-0"
                  v-if="wTimeStat"
                >
                  <!-- DATE -->
                  <date-month-picker
                    label="Gönderme Tarihi"
                    :disable-prev="true"
                    :rules="[
                      $rules.required({
                        falseValues: [''],
                        message: 'Tarih seçimi yapmalısınız',
                      }),
                    ]"
                    @on:date-selected="
                      (val) => {
                        date = val;
                        dateSelected = true;
                      }
                    "
                  >
                  </date-month-picker>
                </v-flex>
                <v-flex
                  xs12
                  class="pt-0 pb-0"
                  v-if="wTimeStat"
                >
                  <!-- TIME -->
                  <time-picker
                    label="Gönderme Saati"
                    :valid="dateSelected"
                    :rules="[$rules.empty('Gönderme Saati')]"
                    @on:time-selected="
                      (val) => {
                        time = ` ${val}:00`;
                      }
                    "
                  >
                  </time-picker>
                </v-flex>
                <v-flex
                  xs12
                  v-if="$store.state.iys_status === 1"
                >
                  <message-type @type="(val) => (message_content_type = val)"></message-type>
                </v-flex>
              </v-flex>

              <!-- SAĞ -->
              <v-flex
                xs12
                md8
              >
                <v-col cols="12">
                  <button-keys
                    v-if="data.keys"
                    :keys="data.keys"
                    item-value="value"
                    class="ma-0 gap-0h"
                    @on:button-key="
                      (val) => {
                        msgBox += ` ${val}`;
                      }
                    "
                  >
                  </button-keys>
                  <sms-message
                    label="Mesajınız"
                    required
                    :rules="[
                      $rules.empty('Mesaj'),
                      (v) =>
                        prepareSms.message_type === 'turkce'
                          ? v.length <= 877 ||
                            'Maksimum karakter sayısı 882 olabilir.'
                          : prepareSms.message_type === 'normal' || true,
                    ]"
                    :value="msgBox"
                    :c-message="msgBox"
                    :c-type="prepareSms.message_type"
                    @text:change="
                      (val) => {
                        msgBox = val;
                      }
                    "
                  >
                  </sms-message>
                </v-col>
              </v-flex>
            </v-row>
          </v-form>
        </v-container>
        <v-card-actions class="gap-1">
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('on:close')"
          >Kapat ve Devam et</v-btn>
          <sms-confirmation
            :context="confirmation.context"
            :valid="confirmation.valid"
            @on:disagree="
            () => {
              $trigger('setPluginDialog');
              $emit('update:confirmation', !confirmation.valid);
              // confirmation.valid = !confirmation.valid;
            }
          "
            @on:agree="prepareButton"
          >
            <template v-slot:activator>
              <v-btn
                color="primary"
                @click="previewButton"
              >Gönder</v-btn>
            </template>
          </sms-confirmation>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { types } from '../../../misc';
import SendersOrMessageTypes from '../SMSConstants/SendersOrMessageTypes.vue';
import ButtonKeys from '../SMSConstants/ButtonKeys.vue';
import TemplateSelector from '../SMSConstants/TemplateSelector.vue';
import DateMonthPicker from '../SMSConstants/DateMonthPicker.vue';
import TimePicker from '../SMSConstants/TimePicker.vue';
import SmsMessage from '../SMSConstants/SmsMessage.vue';
import TimeType from '../SMSConstants/TimeType.vue';
import SmsConfirmation from '../SMSConfirmation.vue';
import MessageType from '../SMSConstants/MessageType.vue';

export default {
  name: 'Prepare',
  components: {
    SmsConfirmation,
    TimeType,
    SmsMessage,
    TimePicker,
    DateMonthPicker,
    TemplateSelector,
    ButtonKeys,
    SendersOrMessageTypes,
    MessageType,
  },
  props: {
    valid: {
      type: Boolean,
    },
    confirmation: {},
    data: {},
  },
  data: () => ({
    types,
    txt: '',
    wTimeStat: false,
    dateSelected: false,
    prepareSms: {
      message_type: '',
      sender: '',
    },
    date: '',
    time: '',
    message_content_type: null,
  }),

  computed: {
    msgBox: {
      get() {
        return this.txt || '';
      },
      set(v) {
        this.txt = v;
      },
    },
  },

  watch: {
    data(nv) {
      if (this.prepareSms.message_type !== '' && this.prepareSms.sender !== '') {
        this.prepareSms.message_type = nv.default_message_type;
        // eslint-disable-next-line prefer-destructuring
        this.prepareSms.sender = nv.senders[0];
      }
    },
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    setInitialStates() {
      this.prepareSms.message_type = this.data.default_message_type;
      // eslint-disable-next-line prefer-destructuring
      this.prepareSms.sender = this.data.senders[0];
    },
    prepareLocals() {
      this.prepareSms.send_time = this.date + this.time;
      this.prepareSms.message = this.msgBox;
      this.prepareSms.message_content_type = this.message_content_type;

      if (!this.wTimeStat) {
        delete this.prepareSms.send_time;
      }
    },
    prepareButton() {
      this.$emit('update:confirmation', this.$refs.prepare.validate());
      // this.confirmation.valid = this.$refs.prepare.validate();
      this.prepareLocals();

      if (this.$refs.prepare.validate()) {
        this.$emit('on:send', this.prepareSms);
        this.$emit('on:close');
      }
    },
    previewButton() {
      this.prepareLocals();
      this.$emit('update:confirmation', this.$refs.prepare.validate());

      if (this.$refs.prepare.validate()) {
        this.$emit('on:preview', this.prepareSms);
      }
    },
    // resets form and associated data
    resetForm() {
      this.$refs.form.reset();
      this.wTimeStat = false;
    },
  },

  events: {
    setInitials: 'setInitialStates',
  },
};
</script>
